import {
  AlertTriangle,
  ArrowLeftRight,
  BarChart2,
  Bot,
  Calendar,
  Check,
  CheckCircle,
  CheckCircle2,
  Circle,
  ClipboardList,
  Clock,
  Crown,
  DollarSign,
  Eye,
  EyeOff,
  Handshake,
  Hourglass,
  Landmark,
  Lightbulb,
  Lock,
  MapPin,
  Medal,
  Megaphone,
  Minus,
  Moon,
  Orbit,
  Package,
  Pause,
  Play,
  Plus,
  RefreshCw,
  RotateCcw,
  Scale,
  Shield,
  Star,
  Stethoscope,
  Sun,
  Swords,
  Target,
  Tent,
  Trophy,
  User,
  Wind,
  Wrench,
  X,
  XCircle,
  Zap,
} from 'lucide-react';

export const iconMap = {
  // App shell
  '⚡': Zap,
  '📣': Megaphone,
  '🌙': Moon,
  '☀️': Sun,
  '👤': User,
  '🔒': Lock,
  '⏳': Hourglass,

  // Status / feedback
  '✅': CheckCircle,
  '❌': XCircle,
  '⚠️': AlertTriangle,

  // League / rankings
  '🏆': Trophy,
  '👑': Crown,
  '🏥': Stethoscope,
  '🔄': RefreshCw,
  '🏕️': Tent,

  // Trade tools
  '⚖️': Scale,
  '🤖': Bot,
  '📊': BarChart2,
  '💡': Lightbulb,
  '🎯': Target,
  '➕': Plus,
  '➖': Minus,

  // Intel / archetypes
  '📋': ClipboardList,
  '🏛️': Landmark,
  '⚔️': Swords,
  '⏰': Clock,
  '🔧': Wrench,
  '🥷': EyeOff,
  '🌪️': Wind,
  '🛡️': Shield,
  '📦': Package,
  '🌀': Orbit,

  // Achievements
  '⭐': Star,
  '👀': Eye,
  '🥈': Medal,

  // Stats sections
  '📅': Calendar,
  '🤝': Handshake,
  '📍': MapPin,
  '🕐': Clock,
  '💰': DollarSign,

  // Draft verdicts
  '🟢': CheckCircle2,
  '🔴': XCircle,
  '⚪': Circle,

  // Unicode text characters
  '↻': RotateCcw,
  '⇄': ArrowLeftRight,
  '✓': Check,
  '✕': X,
  '⏸': Pause,
  '▶': Play,
};
